interface Questions {
  "3": string;
  "5": string;
  "7": string;
  "10": string;
}

interface Translation {
  makeDecision: string;
  enterQuestion: string;
  shouldI: string;
  start: string;
  generatingQuestions: string;
  yes: string;
  no: string;
  makeAnotherDecision: string;
  numberOfQuestions: string;
  questions: Questions;
}

const translations = {
  en: {
    makeDecision: "Make a Decision",
    enterQuestion: "Enter your yes/no question below",
    shouldI: "Should I...",
    start: "Start",
    generatingQuestions: "Generating Questions...",
    yes: "Yes",
    no: "No",
    makeAnotherDecision: "Make Another Decision",
    numberOfQuestions: "Number of questions",
    questions: {
      "3": "3 Questions",
      "5": "5 Questions",
      "7": "7 Questions",
      "10": "10 Questions"
    }
  },
  es: {
    makeDecision: "Tomar una Decisión",
    enterQuestion: "Ingresa tu pregunta de sí/no abajo",
    shouldI: "Debería...",
    start: "Comenzar",
    generatingQuestions: "Generando Preguntas...",
    yes: "Sí",
    no: "No",
    makeAnotherDecision: "Tomar Otra Decisión",
    numberOfQuestions: "Número de preguntas",
    questions: {
      "3": "3 Preguntas",
      "5": "5 Preguntas",
      "7": "7 Preguntas",
      "10": "10 Preguntas"
    }
  },
  fr: {
    makeDecision: "Prendre une Décision",
    enterQuestion: "Entrez votre question oui/non ci-dessous",
    shouldI: "Devrais-je...",
    start: "Commencer",
    generatingQuestions: "Génération des Questions...",
    yes: "Oui",
    no: "Non",
    makeAnotherDecision: "Prendre une Autre Décision",
    numberOfQuestions: "Nombre de questions",
    questions: {
      "3": "3 Questions",
      "5": "5 Questions",
      "7": "7 Questions",
      "10": "10 Questions"
    }
  },
  de: {
    makeDecision: "Eine Entscheidung treffen",
    enterQuestion: "Geben Sie Ihre Ja/Nein-Frage unten ein",
    shouldI: "Sollte ich...",
    start: "Beginnen",
    generatingQuestions: "Fragen werden generiert...",
    yes: "Ja",
    no: "Nein",
    makeAnotherDecision: "Weitere Entscheidung treffen",
    numberOfQuestions: "Anzahl der Fragen",
    questions: {
      "3": "3 Fragen",
      "5": "5 Fragen",
      "7": "7 Fragen",
      "10": "10 Fragen"
    }
  }
} as const;

export type Language = keyof typeof translations;

export const useTranslation = (lang: Language) => {
  return (key: keyof Translation): string => {
    const value = translations[lang][key];
    if (typeof value === 'string') {
      return value;
    }
    // If it's the questions object, return an empty string
    // This should never happen in practice as we handle questions separately
    return '';
  };
};

// Separate function to handle questions specifically
export const getQuestions = (lang: Language): Questions => {
  return translations[lang].questions;
};